import React from "react";
import ConfirmationModal from "@enerex/unified-ui-react/ConfirmationModal";
import Table from "@enerex/unified-ui-react/Table";
import { textOrDash } from "../utilityUtils";

const formatHistoryDate = (value) => {
  if (typeof value !== "string" || !value) return value;
  const match = value.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}:\d{2})(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/);
  if (!match) return value;

  // Format the supplied wall-clock time, without converting its timezone.
  const timestamp = `${match[1]}T${match[2]}`;
  const date = new Date(`${timestamp}Z`);
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 19) !== timestamp) return value;
  const month = date.toLocaleString("en-US", { month: "short", timeZone: "UTC" });
  return `${month} ${match[1].slice(8, 10)}, ${match[1].slice(0, 4)} ${match[2]}`;
};

const HIDDEN_COLUMNS = new Set([
  "UpdatedDateTime",
  "CreatedDateTime",
  "CreatedByName",
  "Deleted",
  "Id",
  "SupplierEXID",
  "SupplierId",
]);

const normalizeHistoryRows = (history = []) =>
  history.filter((row) => {
    const columnName = row?.columnName || row?.ColumnName || "";
    return !HIDDEN_COLUMNS.has(columnName);
  });

const HistoryModal = ({ show, onHide, history }) => {
  const rows = normalizeHistoryRows(history);
  const columns = [
    {
      id: "module",
      header: "Module",
      cell: ({ row }) => textOrDash(row.original.module || row.original.Module),
    },
    {
      id: "operation",
      header: "Operation",
      cell: ({ row }) => textOrDash(row.original.operation || row.original.Operation),
    },
    {
      id: "column",
      header: "Column",
      cell: ({ row }) => textOrDash(row.original.columnName || row.original.ColumnName),
    },
    {
      id: "oldValue",
      header: "Old Value",
      cell: ({ row }) => textOrDash(row.original.oldValue || row.original.OldValue),
    },
    {
      id: "newValue",
      header: "New Value",
      cell: ({ row }) => textOrDash(row.original.newValue || row.original.NewValue),
    },
    {
      id: "createdBy",
      header: "Created By",
      cell: ({ row }) => textOrDash(row.original.performedBy || row.original.PerformedBy || row.original.userName),
    },
    {
      id: "createdOn",
      header: "Created On",
      cell: ({ row }) => textOrDash(formatHistoryDate(row.original.performedOn || row.original.PerformedOn)),
    },
  ];

  return (
   <ConfirmationModal
    dialogClassName="modal-md"
    centered
    size="xl"
    show={show}
    onHide={onHide}
    title="Utility History"
    confirmButtonLabel="Close"
    onConfirm={onHide}
  >
      <Table
        id="utility-history"
        columns={columns}
        data={rows}
        total={rows.length}
        enableSearch={false}
        enablePagination={false}
        enableHideColumns={false}
        enableSorting={false}
        enableFilters={false}
        enableSelection={false}
        enablePaginateAll={false}
        enableColumnVisibilityStorage={false}
        enableGlobalFilterStorage={false}
        enableUrlPagination={false}
        noDataMessage="No history found."
      />
  </ConfirmationModal>
  );
};

export default HistoryModal;
